"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaBrazeProvider = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var braze = __importStar(require("@braze/web-sdk"));
var immutable_1 = require("immutable");
var index_1 = require("../../config/index");
var environment_1 = require("../../config/environment");
var selectors_1 = require("../../services/auth/selectors");
function normalizeBrazeSdkBaseUrl(endpoint) {
    var trimmed = endpoint.trim();
    if (!trimmed)
        return '';
    try {
        if (trimmed.includes('://')) {
            return new URL(trimmed).host;
        }
    }
    catch (_a) {
        // fall through
    }
    return trimmed.replace(/^https?:\/\//i, '');
}
var isTestEnvironment = process.env.NODE_ENV === 'test' || process.env.BROWSER_TEST;
var config = (0, environment_1.isBrowser)() ? (0, index_1.get)() : null;
var isBrazeFeatureOn = !!((_a = config === null || config === void 0 ? void 0 : config.features) === null || _a === void 0 ? void 0 : _a.braze);
var brazeApiKey = (config === null || config === void 0 ? void 0 : config.brazeWebSdkApiKey) || '';
var brazeEndpointRaw = (config === null || config === void 0 ? void 0 : config.brazeSdkEndpoint) || '';
var brazeBaseUrl = normalizeBrazeSdkBaseUrl(brazeEndpointRaw);
var brazeInitializeSucceeded = false;
if ((0, environment_1.isBrowser)()
    && isBrazeFeatureOn
    && brazeApiKey
    && brazeBaseUrl
    && !isTestEnvironment) {
    var enableLogging = process.env.NODE_ENV === 'development';
    brazeInitializeSucceeded = braze.initialize(brazeApiKey, __assign({ baseUrl: brazeBaseUrl }, (enableLogging ? { enableLogging: true } : {})));
}
/**
 * Syncs Braze user identity with Redux auth: changeUser when logged in;
 * wipeData only on transition from logged-in to anonymous (logout).
 */
var BrazeUserSync = function () {
    var auth = (0, react_redux_1.useSelector)(selectors_1.selectAuth);
    var prevUidRef = (0, react_1.useRef)(undefined);
    var initialSessionOpenedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!brazeInitializeSucceeded)
            return;
        var uidRaw = immutable_1.Map.isMap(auth) ? auth.get('uid') : undefined;
        var uid = uidRaw != null && String(uidRaw).trim() !== ''
            ? String(uidRaw)
            : undefined;
        var prevUid = prevUidRef.current;
        if (uid) {
            if (uid !== prevUid) {
                braze.changeUser(uid);
                braze.openSession();
                prevUidRef.current = uid;
            }
            initialSessionOpenedRef.current = true;
            return;
        }
        if (prevUid) {
            braze.wipeData();
            braze.openSession();
            prevUidRef.current = undefined;
            initialSessionOpenedRef.current = true;
            return;
        }
        if (!initialSessionOpenedRef.current) {
            braze.openSession();
            initialSessionOpenedRef.current = true;
        }
    }, [auth]);
    return null;
};
/**
 * Initializes Braze Web SDK when features.braze, API key, and endpoint are set (no OneTrust gate).
 * Renders identity sync for changeUser / wipeData(on logout) and openSession ordering.
 */
var GaiaBrazeProvider = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        brazeInitializeSucceeded ? react_1.default.createElement(BrazeUserSync, null) : null,
        children));
};
exports.GaiaBrazeProvider = GaiaBrazeProvider;
exports.default = exports.GaiaBrazeProvider;
